import script from "./PreActionFlowBasedRedirect.vue?vue&type=script&lang=js"
export * from "./PreActionFlowBasedRedirect.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__